import {
  Alert,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Snackbar,
} from "@mui/material";
import Slide from "@mui/material/Slide";

import { useDisclosure } from "hooks";

interface Props {
  value: QuoteFilterType;
  onChange: (value: QuoteFilterType) => void;
  shipmentBooked: boolean;
  showCountered: boolean;
  showCancelled: boolean;
}

export function QuoteFilterDropdown(props: Props) {
  const {
    value,
    onChange: OnMenuOptionSelected,
    shipmentBooked,
    showCountered,
    showCancelled,
  } = props;

  const { isOpen, onClose, onOpen } = useDisclosure(false);

  const onChange = (selection: QuoteFilterType) => {
    onOpen();
    OnMenuOptionSelected(selection);
  };

  return (
    <>
      <FormControl sx={{ minWidth: 200 }} size="small">
        <InputLabel>Filter</InputLabel>
        <Select
          value={value}
          label="Filter"
          size="small"
          onChange={(e) => onChange(e.target.value as QuoteFilterType)}
        >
          {shipmentBooked && <MenuItem value="ACCEPTED">ACCEPTED</MenuItem>}
          <MenuItem value="ALL">All</MenuItem>
          <MenuItem value="PARTNER">Partner</MenuItem>
          {shipmentBooked && <MenuItem value="LOST">Lost</MenuItem>}
          {!shipmentBooked && <MenuItem value="ACTIVE">Active</MenuItem>}
          {!shipmentBooked && showCountered && (
            <MenuItem value="COUNTERED">Countered</MenuItem>
          )}
          {showCancelled && <MenuItem value="CANCELLED">Cancelled</MenuItem>}
          <MenuItem value="BY_TRUCKING_COMPANY">Trucking company</MenuItem>
          <MenuItem value="BY_BROKER">Broker</MenuItem>
        </Select>
      </FormControl>

      <Snackbar
        id={value}
        open={isOpen}
        autoHideDuration={1000}
        onClose={onClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        TransitionComponent={Slide}
      >
        <Alert onClose={onClose} severity="success" sx={{ width: "100%" }}>
          Filter Applied!
        </Alert>
      </Snackbar>
    </>
  );
}
